import NumberInput from "@components/hookform/NumberInput";
import { Control } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";

export interface InputFieldProps<T extends FieldValues> {
  control: Control<T>;
  fieldDefinition: FormFieldDefinition<T>;
  autoFocus?: boolean;
}

const NumberField = <T extends FieldValues>({
  control,
  fieldDefinition,
  autoFocus,
}: InputFieldProps<T>) => {
  return (
    <div className="flex relative max-w-[360px]">
      <NumberInput
        autoFocus={autoFocus}
        control={control}
        name={fieldDefinition.name}
        label={fieldDefinition.label}
        info={fieldDefinition.info}
        suffix={fieldDefinition.suffix}
        data-testid={fieldDefinition.name}
        rules={fieldDefinition.rules}
        placeholder={fieldDefinition.placeholder}
        inputMode={fieldDefinition.inputMode}
        defaultValue={fieldDefinition.defaultValue}
      />
    </div>
  );
};

export default NumberField;
